import { render, staticRenderFns } from "./ComponentWaitItem.vue?vue&type=template&id=4c41218f&scoped=true&"
import script from "./ComponentWaitItem.vue?vue&type=script&lang=js&"
export * from "./ComponentWaitItem.vue?vue&type=script&lang=js&"
import style0 from "./ComponentWaitItem.vue?vue&type=style&index=0&id=4c41218f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c41218f",
  null
  
)

export default component.exports